module.exports = __webpack_public_path__ + "static/gallery-16-5be6d87e002e57be1a475cc3fccc969c.jpg";